import { render, staticRenderFns } from "./DrawingMenuItem.vue?vue&type=template&id=c1dcaaf4&scoped=true"
import script from "./DrawingMenuItem.vue?vue&type=script&lang=js"
export * from "./DrawingMenuItem.vue?vue&type=script&lang=js"
import style0 from "./DrawingMenuItem.vue?vue&type=style&index=0&id=c1dcaaf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dcaaf4",
  null
  
)

export default component.exports